import React from 'react';
import PropTypes from 'prop-types';
import './MultipleButtonSelect.scss';

const formattedStr = (str) => str.toLowerCase().replace(/\s+/g, '-');

function MultipleButtonSelect({ options, handleChange, selected }) {
  return (
    <div className="filter-tag-container">
      {
      options.map((option) => (
        <button
          className={`filter-tag ${formattedStr(option)} ${selected.includes(option)
            ? 'filtertag-selected'
            : ''}`}
          name={formattedStr(option)}
          id={`tag-${formattedStr(option)}`}
          onClick={() => handleChange(option)}
        >
          {option}
        </button>
      ))
    }
    </div>
  );
}

MultipleButtonSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.string,
};

MultipleButtonSelect.defaultProps = {
  selected: null,
};

export default MultipleButtonSelect;
